// extracted by mini-css-extract-plugin
var _1 = "Z_znYgPmNgrs_a1XEe7P";
export { _1 as "content" }
